<div class="w-full bg-white shadow-sm border border-slate-200 rounded-xl overflow-hidden">
  @if (titulo() !== undefined) {
    <div class="px-3 sm:px-5 py-3 sm:py-4 border-b border-slate-100">
      <h3
        class="text-base sm:text-lg font-semibold text-slate-800 flex items-center gap-2 truncate"
      >
        <i class="bi bi-list text-accent-500 shrink-0"></i>
        <span class="truncate">{{ titulo() }}</span>
      </h3>
    </div>
  }
  <div class="overflow-x-auto">
    <table class="min-w-full divide-y divide-slate-100">
      <thead class="bg-slate-50/80">
        <tr>
          @for (col of columnas(); track col.key) {
            <th
              class="px-3 sm:px-4 py-2.5 sm:py-3 text-left text-xs font-semibold text-slate-500 uppercase tracking-wider whitespace-nowrap"
              [class.text-center]="col.align === 'center'"
              [class.text-right]="col.align === 'right'"
            >
              {{ col.titulo }}
            </th>
          }
          @if (accionesTemplate() || !ocultarAcciones()) {
            <th
              class="px-3 sm:px-4 py-2.5 sm:py-3 text-center text-xs font-semibold text-slate-500 uppercase tracking-wider whitespace-nowrap"
            >
              Acciones
            </th>
          }
        </tr>
      </thead>
      <tbody class="divide-y divide-slate-50 bg-white">
        @if (loading()) {
          <tr>
            <td
              [attr.colspan]="columnas().length + 1"
              class="py-8 text-center text-slate-400 text-xs sm:text-sm"
            >
              <app-progress-spinner size="20" strokeWidth="3" />
            </td>
          </tr>
        } @else if (datos().length === 0) {
          <tr>
            <td [attr.colspan]="columnas().length + 1" class="py-10 text-center">
              <div class="flex flex-col items-center gap-2">
                <i class="bi bi-inbox text-3xl text-slate-300"></i>
                <span class="text-sm text-slate-400">{{ textoVacio() }}</span>
              </div>
            </td>
          </tr>
        } @else {
          @for (row of datos(); track $index) {
            <tr class="hover:bg-slate-50/70 transition-colors duration-100 text-xs sm:text-sm">
              @for (col of columnas(); track col.key) {
                @if (col.type === 'image') {
                  <td class="px-3 sm:px-4 py-2.5 sm:py-3 align-middle text-center">
                    @if (getImageForColumn(row, col)) {
                      <img
                        [src]="getImageForColumn(row, col)"
                        alt="{{ col.titulo }}"
                        [class]="
                          (col.imageClass ?? 'h-8 w-8 rounded-lg object-cover mx-auto') +
                          ' transition-transform duration-150 ease-in-out hover:scale-110'
                        "
                      />
                    } @else {
                      <i
                        class="{{
                          (col.fallbackIcon ?? 'bi bi-image') + ' text-slate-300 text-2xl'
                        }}"
                      ></i>
                    }
                  </td>
                } @else {
                  <td
                    class="px-3 sm:px-4 py-2.5 sm:py-3 align-middle text-slate-700"
                    [class.text-center]="col.align === 'center'"
                    [class.text-right]="col.align === 'right'"
                  >
                    @if (col.template) {
                      <ng-container
                        [ngTemplateOutlet]="col.template"
                        [ngTemplateOutletContext]="{ $implicit: row }"
                      ></ng-container>
                    } @else {
                      @if (col.pipe) {
                        {{ transformValue(getNestedValue(row, col.key), col.pipe, col.pipeFormat) }}
                      } @else {
                        {{ getNestedValue(row, col.key) }}
                      }
                    }
                  </td>
                }
              }
              @if (accionesTemplate() || !ocultarAcciones()) {
                <td class="px-3 sm:px-4 py-2.5 sm:py-3 text-center">
                  <div class="flex gap-1 sm:gap-1.5 justify-center flex-wrap">
                    @if (accionesTemplate()) {
                      <ng-container
                        [ngTemplateOutlet]="accionesTemplate()"
                        [ngTemplateOutletContext]="{ $implicit: row }"
                      ></ng-container>
                    } @else {
                      <app-button
                        icon="bi bi-pencil"
                        variant="ghost"
                        size="xs"
                        ariaLabel="Editar"
                        (onClick)="onEditar(row)"
                      />
                      <app-button
                        icon="bi bi-trash"
                        variant="ghost"
                        size="xs"
                        ariaLabel="Eliminar"
                        (onClick)="onEliminar(row)"
                      />
                    }
                  </div>
                </td>
              }
            </tr>
          }
        }
      </tbody>
    </table>
  </div>
</div>
